import API from "./API/Sticker";

const Sticker = {

    exists(){
        return window.localStorage.getItem('sticker') ? true : false;
    },

    getAction(){
        return {
            id: window.localStorage.getItem('sticker')
        }
    },

    stick(id){
        window.localStorage.setItem('sticker', id);
        return this;
    },

    track(event, data){

        if( !this.exists() ) return false;

        const e = {
            id: data?.id || null,
            type: {id: event},
            action: this.getAction(),
            course: data?.product || null,
            user: data?.user,
            value: data?.value || 0
        }

        API.postEvent(e)
            .then(r => console.log(r.data))
            .catch(e => console.log(e.response?.data))

        return this;
    },

};

export default Sticker;
